// extracted by mini-css-extract-plugin
module.exports = {"frameWrapper":"style__frameWrapper__9sZNL","frame":"style__frame__RWp4C","selected":"style__selected__-hokw","thumbnail":"style__thumbnail__jk+AT","label":"style__label__C8bM+"};